export default {

    computed: {

        assessmentVersionStatus() {
            return [
                {
                    value: 'DRAFT',
                    desc: '草稿',
                    disabled: true
                },
                {
                    value: 'ACTIVE',
                    desc: '活动',
                    disabled: false
                },
                {
                    value: 'INACTIVE',
                    desc: '不活动',
                    disabled: false
                },

            ]
        },

    },

}